import FormHelperText from "@mui/material/FormHelperText";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import isBoolean from "lodash/isBoolean";
import isFunction from "lodash/isFunction";
import { useEffect, useMemo } from "react";
import { Field } from "react-final-form";
import { FIELD_TYPES, useFormContext } from "../../../context/FormContext";
import { VALIDATOR_REQUIRE } from "../../../utils/finalForm/validators/VALIDATOR_REQUIRE";
import RffInputWrapper from "../shared/RffInputWrapper";

const RffBooleanSwitchField = ({
  name,
  label,
  description,
  required = false,
  suppressGrid,
  onChange,
  size,
  helperText,
  sx,
  switchProps,
}) => {
  const { registerFieldType } = useFormContext();

  const validate = useMemo(
    () => (required ? VALIDATOR_REQUIRE : undefined),
    [required],
  );

  useEffect(() => {
    if (name) {
      registerFieldType(name, FIELD_TYPES.BOOLEAN_SWITCH || "BOOLEAN_SWITCH");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

  return (
    <RffInputWrapper
      suppressGrid={suppressGrid}
      size={size}
      required={required}
      helperText={helperText}
    >
      <Field
        name={name}
        validate={validate}
        render={({ input, meta }) => {
          const checked = isBoolean(input.value) ? input.value : false;
          const fieldType = FIELD_TYPES.BOOLEAN_SWITCH || "BOOLEAN_SWITCH";

          return (
            <>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                  width: "100%",
                  ...sx,
                }}
              >
                <Box sx={{ minWidth: 0, flex: 1 }}>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: 1.3,
                      color: "text.primary",
                    }}
                  >
                    {label}
                  </Typography>

                  {description ? (
                    <Typography
                      sx={{
                        mt: 0.25,
                        fontSize: "12px",
                        lineHeight: 1.4,
                        color: "text.secondary",
                      }}
                    >
                      {description}
                    </Typography>
                  ) : null}
                </Box>

                <Switch
                  checked={checked}
                  onChange={(event) => {
                    const nextValue = event.target.checked;
                    input.onChange(nextValue);

                    if (isFunction(onChange)) {
                      onChange(nextValue);
                    }
                  }}
                  data-type={fieldType}
                  {...switchProps}
                />
              </Box>

              {meta.touched && meta.error && (
                <FormHelperText error>{meta.error}</FormHelperText>
              )}
            </>
          );
        }}
      />
    </RffInputWrapper>
  );
};

export default RffBooleanSwitchField;
